<template>
    <div>
        <div v-if="isProduction" class="page-school">
            <div class="block-control">
                <div class="block-control__left" v-if="langs_school">
                    <DropdownDefault
                            class-dropdown="school-drop"
                            v-model="access"
                            v-bind:items="access_list"
                            value_key="id"
                            text="type"
                            dropSlot
                    >
                        <template v-slot:selection="item">
                            {{item.name}}
                        </template>
                        <template v-slot:item="item">
                            {{item.name}}
                        </template>
                    </DropdownDefault>

                    <DropdownDefault
                            class-dropdown="school-drop"
                            v-model="lang_school"
                            v-bind:items="langs_school"
                            value_key="id"
                            text="lang"
                            dropSlot
                            v-on:change="changeLang"
                    >
                        <template v-slot:selection="item">
                            <img width="20" :src="`/newfrontend/images/flags/${(typeof item == 'string') ? item : item.lang}.svg`" />
                            {{item.full_lang}}
                        </template>
                        <template v-slot:item="item">
                            <img width="20" :src="`/newfrontend/images/flags/${(typeof item == 'string') ? item : item.lang}.svg`" />
                            {{item.full_lang}}
                        </template>
                    </DropdownDefault>
                </div>
                <div class="block-control__right">
                    <div class="tabs">
                        <div class="tabs__item" v-for="(i, key) in 5" @click="updateLvl(i)" :class="(i== level) ? 'active' : ''" :key="key">
                            {{__('academy_Level')}} {{i}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-school__body" v-if="loading">
                <div class="not-open" v-if="close">
                    <img src="/newfrontend/images/noun-lock.png" alt="">
                    <p>{{__('This is a closed section of the site!')}}</p>
                    <span class="text">{{__('In order to access this section, write to us in our telegram chat')}}</span>
                    <a href="https://t.me/mediachaininc" target="_blank">
                        <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4809 0.691699C15.6868 0.605024 15.9122 0.575131 16.1336 0.60513C16.355 0.635128 16.5643 0.723922 16.7398 0.86227C16.9152 1.00062 17.0504 1.18346 17.1312 1.39177C17.212 1.60007 17.2355 1.82623 17.1992 2.0467L15.3092 13.5109C15.1259 14.6167 13.9125 15.2509 12.8984 14.7C12.05 14.2392 10.79 13.5292 9.6567 12.7884C9.09004 12.4175 7.3542 11.23 7.56754 10.385C7.75087 9.66253 10.6675 6.94753 12.3342 5.33336C12.9884 4.6992 12.69 4.33336 11.9175 4.9167C9.99837 6.36503 6.9192 8.56753 5.90087 9.18753C5.00254 9.7342 4.5342 9.82753 3.9742 9.7342C2.95254 9.5642 2.00504 9.30087 1.2317 8.98003C0.186704 8.5467 0.237537 7.11003 1.23087 6.6917L15.4809 0.691699Z" fill="white"/>
                        </svg>
                        <span>{{__('write to telegram')}}</span>
                    </a>
                </div>

                <div class="block-videos" v-else-if="videos && videos.length">
                    <div class="wrapper-video">
                        <VideoItem v-for="(item, key) in videos" :key="key" v-bind:item.sync="item"></VideoItem>
                    </div>
                </div>

                <div class="block-no-result" v-else-if="videos && !videos.length">
                    <svg width="140" height="130" viewBox="0 0 140 130" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M47.7202 83.8785C40.6291 83.8785 34.877 89.661 34.877 96.7524C34.877 103.844 40.6291 109.626 47.7202 109.626C54.8113 109.626 60.5634 103.844 60.5634 96.7524C60.5634 89.661 54.7809 83.8785 47.7202 83.8785ZM47.7202 106.583C42.3028 106.583 37.9202 102.17 37.9202 96.7524C37.9202 91.335 42.3028 86.9221 47.7202 86.9221C53.1375 86.9221 57.5201 91.335 57.5201 96.7524C57.5201 102.17 53.1072 106.583 47.7202 106.583Z" fill="#C4C4C4"/>
                        <path d="M70.4539 36.1881L50.7325 24.7751C48.8151 23.649 46.5021 23.649 44.5846 24.7751C42.6368 25.9012 41.5107 27.8793 41.5107 30.1315V52.9572C41.5107 55.1789 42.6672 57.1875 44.5846 58.3136C45.5585 58.8615 46.5933 59.1354 47.6585 59.1354C48.7238 59.1354 49.7889 58.8615 50.7325 58.2832L70.4539 46.8702C72.3712 45.7442 73.5278 43.766 73.5278 41.5138C73.5278 39.2921 72.3713 37.3138 70.4539 36.1877V36.1881ZM68.9017 44.2531L49.1803 55.666C48.2064 56.2443 47.0499 56.2443 46.0761 55.666C45.1022 55.0878 44.5239 54.0835 44.5239 52.9574V30.1317C44.5239 29.0056 45.1022 27.9709 46.0761 27.423C46.563 27.1491 47.1109 26.997 47.6282 26.997C48.1761 26.997 48.6934 27.1492 49.1804 27.423L68.9018 38.836C69.8757 39.4143 70.4539 40.4186 70.4539 41.5447C70.4844 42.6708 69.9061 43.6751 68.9018 44.2533L68.9017 44.2531Z" fill="#C4C4C4"/>
                        <path d="M139.662 115.102L118.967 90.1151C123.319 86.6761 126.301 81.837 127.427 76.3283C129.558 65.7373 124.201 55.3592 115.01 50.6722V5.53898C115.01 2.49541 112.545 0 109.501 0H5.50865C2.46507 0 0 2.46519 0 5.53898V77.5462C0 80.5898 2.46519 83.0852 5.50865 83.0852H25.6867L26.0215 83.42C24.5911 85.733 23.5867 88.2285 22.9476 90.8461H21.0911C17.8346 90.8461 15.1867 93.4939 15.1867 96.7504C15.1867 100.007 17.8345 102.655 21.0911 102.655H22.9476C23.5563 105.272 24.591 107.768 26.0215 110.081L24.7128 111.39C22.3998 113.703 22.3998 117.446 24.7128 119.759C25.8389 120.885 27.2997 121.494 28.8822 121.494C30.4647 121.494 31.9561 120.885 33.0516 119.759L34.3603 118.45C36.6733 119.881 39.1385 120.915 41.7558 121.524V123.381C41.7558 126.637 44.4036 129.285 47.6601 129.285C50.9167 129.285 53.5644 126.637 53.5644 123.381V121.524C56.1818 120.915 58.6774 119.881 60.9599 118.45L62.2686 119.759C63.3947 120.885 64.8555 121.494 66.438 121.494C68.0205 121.494 69.5119 120.885 70.6074 119.759C72.9204 117.446 72.9204 113.702 70.6074 111.39L69.2987 110.081C70.7291 107.768 71.7335 105.272 72.3726 102.655H74.2291C77.4856 102.655 80.1335 100.007 80.1335 96.7504C80.1335 93.4939 77.4857 90.8461 74.2291 90.8461H72.4335C71.8248 88.2288 70.7901 85.7331 69.3596 83.42L69.6944 83.0852H83.8462C87.0723 88.8983 92.7332 93.3415 99.733 94.7417C101.285 95.046 102.868 95.1982 104.42 95.1982C108.65 95.1982 112.759 94.0417 116.441 91.8505L137.319 117.02C137.624 117.385 138.05 117.567 138.506 117.567C138.841 117.567 139.206 117.446 139.48 117.233C140.089 116.715 140.18 115.741 139.663 115.102L139.662 115.102ZM66.1633 84.0594C67.9285 86.6463 69.1459 89.5377 69.6938 92.6113C69.8156 93.3418 70.4547 93.8591 71.1851 93.8591H74.259C75.8416 93.8591 77.1198 95.1374 77.1198 96.7199C77.1198 98.3024 75.8415 99.5807 74.259 99.5807H71.2154C70.485 99.5807 69.8459 100.098 69.7242 100.828C69.1459 103.902 67.959 106.794 66.1936 109.38C65.7676 109.989 65.8589 110.811 66.3762 111.328L68.5675 113.519C69.6936 114.646 69.6936 116.472 68.5675 117.598C68.0197 118.145 67.3197 118.45 66.5588 118.45C65.798 118.45 65.0675 118.145 64.5501 117.598L62.3589 115.406C61.8415 114.889 61.0198 114.798 60.4111 115.224C57.8242 117.019 54.9328 118.206 51.8591 118.785C51.1287 118.906 50.6113 119.545 50.6113 120.276V123.35C50.6113 124.932 49.3331 126.211 47.7506 126.211C46.1681 126.211 44.8898 124.932 44.8898 123.35V120.276C44.8898 119.545 44.3724 118.906 43.642 118.785C40.5681 118.206 37.6767 117.019 35.0901 115.224C34.8162 115.041 34.5422 114.95 34.2379 114.95C33.8423 114.95 33.4466 115.102 33.1727 115.406L30.9814 117.598C30.4336 118.145 29.7336 118.45 28.9728 118.45C28.2119 118.45 27.4815 118.145 26.9641 117.598C25.838 116.472 25.838 114.646 26.9641 113.519L29.1554 111.328C29.6727 110.811 29.7336 109.989 29.338 109.38C27.5728 106.793 26.3553 103.902 25.8074 100.828C25.6857 100.098 25.0466 99.5807 24.3162 99.5807H21.1207C19.5381 99.5807 18.2599 98.3024 18.2599 96.7199C18.2599 95.1374 19.5382 93.8591 21.1207 93.8591H24.1946C24.925 93.8591 25.5641 93.3417 25.6858 92.6113C26.2641 89.5374 27.451 86.6461 29.2164 84.0594C29.4294 83.755 29.5207 83.4203 29.4903 83.055H65.889C65.8586 83.4203 65.9499 83.755 66.1629 84.0594L66.1633 84.0594ZM69.085 80.0116H5.50892C4.13937 80.0116 3.04374 78.8855 3.04374 77.516V5.53931C3.04374 4.16976 4.13937 3.04368 5.50892 3.04368H109.443C110.813 3.04368 111.909 4.16976 111.909 5.53931V49.3953L111.635 49.304C111.482 49.2432 111.361 49.2127 111.209 49.1519C110.904 49.0606 110.6 48.9693 110.296 48.9084C110.204 48.878 110.082 48.8475 109.991 48.8475C109.656 48.7562 109.322 48.6953 108.987 48.604C103.995 47.5997 98.9131 48.2084 94.3784 50.3693C93.6784 50.704 93.0088 51.0692 92.3393 51.4649C92.0045 51.6779 91.6697 51.8605 91.3349 52.104C86.1004 55.5736 82.5395 60.8994 81.3221 67.0472V67.0777C81.2613 67.4429 81.2004 67.7776 81.1395 68.1429C81.1395 68.2342 81.1091 68.295 81.1091 68.3863C80.5309 72.3732 80.9874 76.3601 82.4178 80.0731H69.0876L69.085 80.0116ZM100.342 91.7593C93.7981 90.4506 88.6245 86.0984 85.9462 80.4985C85.9158 80.4681 85.9158 80.4072 85.8854 80.3768L85.5202 79.5551V79.5246C84.3941 76.7855 83.8158 73.8031 83.968 70.7292V70.6684C83.968 70.364 83.9985 70.0901 84.0289 69.7858C84.0289 69.7249 84.0289 69.6336 84.0593 69.5727C84.0898 69.3292 84.1202 69.0858 84.1506 68.8119C84.1506 68.7206 84.1811 68.6292 84.1811 68.5684C84.2419 68.264 84.2724 67.9597 84.3332 67.6249V67.5945C85.3984 62.2381 88.5026 57.612 93.068 54.5687C93.3114 54.3861 93.5854 54.234 93.8593 54.0818C93.9506 54.0209 94.0115 53.9905 94.1028 53.9601C94.2854 53.8383 94.4984 53.747 94.7114 53.6253C94.8027 53.5948 94.8636 53.534 94.9549 53.5035C95.2288 53.3514 95.5028 53.2296 95.7766 53.1079H95.8071C96.081 52.9862 96.3245 52.8644 96.5984 52.7427C96.6897 52.7122 96.7506 52.6818 96.8419 52.6514C97.0549 52.5601 97.2679 52.4688 97.481 52.4079C97.5419 52.3775 97.6332 52.347 97.694 52.3166C97.9679 52.2253 98.2723 52.134 98.5462 52.0427H98.6071C98.881 51.9514 99.1549 51.8905 99.4288 51.8297C99.5201 51.7992 99.581 51.7992 99.6723 51.7688C99.8853 51.7079 100.129 51.6775 100.342 51.6166C100.403 51.6166 100.494 51.5862 100.555 51.5557C100.859 51.4949 101.133 51.434 101.437 51.4036H101.529L102.35 51.3123C102.442 51.3123 102.533 51.2818 102.594 51.2818C102.837 51.2514 103.05 51.2514 103.294 51.221H103.507C103.811 51.221 104.116 51.1905 104.42 51.1905H104.907H105.424C105.607 51.1905 105.79 51.221 105.972 51.221C106.124 51.221 106.276 51.2514 106.459 51.2514C106.672 51.2818 106.885 51.3123 107.068 51.3427C107.189 51.3731 107.342 51.3731 107.463 51.4036L108.468 51.5862C108.833 51.647 109.198 51.7383 109.563 51.8297C109.624 51.8297 109.685 51.8601 109.716 51.8601C110.02 51.9514 110.355 52.0427 110.659 52.134C110.689 52.134 110.75 52.1644 110.781 52.1644C111.116 52.2862 111.42 52.3775 111.755 52.4992C111.785 52.4992 111.816 52.5296 111.846 52.5296C112.181 52.6514 112.485 52.8036 112.789 52.9253C121.281 56.7599 126.363 66.1032 124.446 75.6597C123.381 81.0161 120.276 85.6422 115.711 88.6854C111.146 91.7593 105.698 92.8245 100.342 91.7593L100.342 91.7593Z" fill="#C4C4C4"/>
                    </svg>
                    <p>{{__('academy_There are no videos in this section yet')}}</p>
                </div>
            </div>
            <div v-else class="loading">
                <loaderMc></loaderMc>
                {{__('Loading')}}
            </div>
        </div>

        <ComingSoon v-else></ComingSoon>

    </div>
</template>

<script>

    import loaderMc from "../SvgComponents/loaderMc";
    import DropdownDefault from "../modules/DropdownDefault";
    import VideoItem from "./School/VideoItem";
    import ComingSoon from "./ComingSoon";
    export default {
        name: 'School',
        data: function() {
            return {
                lang_school: null,
                langs_school: null,
                access: 0,
                access_list: [
                    {
                        name: this.__('academy_Open access'),
                        type: 0
                    },
                    {
                        name: this.__('academy_Closed access'),
                        type: 1
                    }
                ],

                level: 1,

                videos: [],
                next_page_url: null,
                loadingPage: false,

                close: true,
                loading: false,
                isProduction: true,
            }
        },
        watch: {
            access() {
                this.lang_school = this.langs_school[0].lang;
                this.changeLang(this.langs_school[0].lang);
            }
        },
        computed: {
            lang() {
                return this.$store.state.language.lang
            },
            school_video_open() {
                return this.$store.getters.school_video_open;
            },
            school_video_close() {
                return this.$store.getters.school_video_close;
            },
        },
        methods:{
            updateLvl(lvl = 1) {
                this.level = lvl;
                if (this.access == 0) {
                    if (this.school_video_open == 'closed') {
                        this.close = true;
                    } else {
                        this.videos = this.school_video_open[this.lang_school][lvl].data;
                        this.next_page_url = this.school_video_open[this.lang_school][lvl].next_page_url;
                    }
                } else {
                    if (this.school_video_close == 'closed') {
                        this.close = true;
                    } else {
                        this.videos = this.school_video_close[this.lang_school][lvl].data;
                        this.next_page_url = this.school_video_close[this.lang_school][lvl].next_page_url;
                    }
                }
            },

            changeLang(lang) {
                if (this.access == 0) {
                    if (this.school_video_open == 'closed') {
                        this.close = true;
                    } else if (Object.keys(this.school_video_open).includes(lang)) {
                        this.updateLvl();
                    } else {
                        this.getVideo(lang, this.access);
                    }
                } else {
                    if (this.school_video_close == 'closed') {
                        this.close = true;
                    } else if (Object.keys(this.school_video_close).includes(lang)) {
                        this.updateLvl();
                    } else {
                        this.getVideo(lang, this.access);
                    }
                }
            },

            getVideo(lang, access = 0) {
                let params = {
                  lang: lang,
                  private: access
                };
                this.loading = false;

                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/video', params)
                    .then(response => {
                        return response.json()
                    })
                    .then((response) => {
                        this.loading = true;
                        this.close = false;
                        response = response.data;

                        if (access == 0) {
                            let school_video_open = this.$cleanObject(this.school_video_open);
                            school_video_open[lang] = response.video;
                            this.$store.dispatch('asyncVideoOpen', school_video_open);
                        } else {
                            let school_video_close = this.$cleanObject(this.school_video_close);
                            school_video_close[lang] = response.video;
                            this.$store.dispatch('asyncVideoClose', school_video_close);
                        }
                        this.updateLvl();
                    }).catch((err) => {
                    if (access == 0) {
                        this.$store.dispatch('asyncVideoOpen', 'closed');
                    } else {
                        this.$store.dispatch('asyncVideoClose', 'closed');
                    }
                    this.loading = true;
                    this.close = true;
                    this.httpHandler(err);
                });
            },

            scrollVideo() {
                const progress = document.documentElement.scrollTop / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
                if (!this.loadingPage && this.next_page_url) {
                    let bottomOfWindow = 0.7 <= progress;
                    if (bottomOfWindow) {
                        this.loadingPage = true;
                        this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get'](this.next_page_url)
                            .then((response) => {
                                return response.json();
                            })
                            .then((response) => {

                                response = response.data;

                                let videos = this.videos;
                                this.videos = videos.concat(response.video[this.level].data);
                                this.next_page_url = response.video[this.level].next_page_url;
                                this.loadingPage = false;
                            })
                            .catch((err) => {
                                this.httpHandler(err);
                            });
                    }
                }
            },
        },
        created() {
            this.$http[(process.env.NODE_ENV === 'production') ? 'get' : 'get']('ajax/lang_school')
                .then(response => {
                    return response.json()
                })
                .then((response) => {
                    response = response.data;

                    this.langs_school = response.languages;
                    this.lang_school = response.languages[0].lang;

                    this.getVideo(response.languages[0].lang);
                }).catch((err) => {
                this.httpHandler(err);
            });

            this.$addListener(window,'scroll',  () => {
                this.scrollVideo();
            });
        },
        mounted() {

        },
        components: {
            loaderMc,
            DropdownDefault,
            VideoItem,
            ComingSoon
        }
    }
</script>

<style scoped>

</style>
